import * as React from 'react';

import * as styles from './DesktopSearchFormLayout.css';
import clsx from 'clsx';
import { Experiment } from '@cian/experiments/ab';
import { BX_DESKTOP_MAIN_PAGE } from 'shared/constants/experiments';

interface IDesktopSearchFormLayoutProps {
  isSearchPage: boolean;
  onSubmit?: (e: React.FormEvent) => void;
}

export const DesktopSearchFormLayout: React.FC<React.PropsWithChildren<IDesktopSearchFormLayoutProps>> = ({
  children,
  isSearchPage,
  onSubmit,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit?.(e);
  };

  return (
    <>
      <Experiment name={BX_DESKTOP_MAIN_PAGE} group="B" default>
        <form
          className={clsx(styles['form'], isSearchPage && styles['search-page'])}
          action="#"
          onSubmit={handleSubmit}
        >
          {children}
        </form>
      </Experiment>

      <Experiment name={BX_DESKTOP_MAIN_PAGE} group="D">
        <form
          className={clsx(styles['form'], isSearchPage && styles['search-page'], styles['form--redesign-d'])}
          action="#"
          onSubmit={handleSubmit}
        >
          {children}
        </form>
      </Experiment>
    </>
  );
};
